import React from 'react';

import Callout from '~components/Callout';

import { DashboardBannerView } from './dashboardFigures';

interface ComponentProps {
  banner: DashboardBannerView;
}

/** One banner for everything over a limit this quarter, one line per limit. */
export const DashboardBanner: React.FC<ComponentProps> = ({ banner }) => (
  <Callout
    tone={banner.tone}
    title={banner.title}
    lines={banner.items.map(({ text }) => text)}
    className="dashboard-banner"
    dataCy="dashboard-banner"
  />
);
